import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { LoginForm } from '../../components/forms/LoginForm';
import { useAuth } from '../../providers/AuthProvider';
import { useNotifications } from '../../providers/NotificationProvider';

export const LoginPage: React.FC = () => {
	const { isAuthenticated, login } = useAuth();
	const { addNotification } = useNotifications();
	const [loading, setLoading] = useState(false);

	if (isAuthenticated) {
		return <Navigate to="/dashboard" replace />;
	}

	const handleLogin = async (email: string, password: string) => {
		setLoading(true);

		try {
			await login(email, password);

			// Success notification - delay slightly to ensure it shows after redirect
			setTimeout(() => {
				addNotification({
					type: 'success',
					title: 'Welcome back!',
					message: 'Successfully logged in to Mergeo Admin Dashboard',
				});
			}, 100);
		} catch (error) {
			console.error('Login failed:', error);
			throw error;
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 relative z-[60]">
			<LoginForm onSubmit={handleLogin} loading={loading} />
		</div>
	);
};
